let count = 0;

export function next() {
  return count++;
}
